import { useEffect, useRef } from "react";
import { type FallbackProps, getErrorMessage } from "react-error-boundary";
import { useLocation } from "react-router";
import { PageWrapper } from "src/general/layout/Page/PageWrapper";
import { ErrorView } from "./ErrorView";

/** An error boundary fallback component that displays when an unexpected error occurs in the application. */
export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const location = useLocation();
  const prevLocationKey = useRef(location.key);

  useEffect(() => {
    if (prevLocationKey.current !== location.key) {
      resetErrorBoundary();
    }
    prevLocationKey.current = location.key;
  }, [location.key, resetErrorBoundary]);

  return (
    <PageWrapper>
      <ErrorView message={getErrorMessage(error)} />
    </PageWrapper>
  );
};
